import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinLimbah = createAsyncThunk(
    "limbah/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMinMasterLimbah",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObjKode = [];
                newObjKode.push({
                    value: "0",
                    label: "All",
                });
                response.data.data.map((item) =>
                    newObjKode.push({
                        value: item.LimbahID,
                        label: item.KodeLimbah,
                    })
                );
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.LimbahID,
                        label: item.NamaLimbah,
                    })
                );
                newObj.push({
                    value: "0",
                    label: "All",
                });
                return {data: newObj, dataKode: newObjKode};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getLimbah = createAsyncThunk(
    "limbah/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMasterLimbah",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertLimbah = createAsyncThunk(
    "limbah/insert",
    async ({NamaLimbah, KodeLimbah}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaLimbah", NamaLimbah);
        formData.append("KodeLimbah", KodeLimbah);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertMasterLimbah",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateLimbah = createAsyncThunk(
    "limbah/update",
    async ({NamaLimbah, LimbahID, KodeLimbah, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaLimbah", NamaLimbah);
        formData.append("LimbahID", LimbahID);
        formData.append("Status", status);
        formData.append("KodeLimbah", KodeLimbah);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateMasterLimbah",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    minDataKode: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const limbahSlice = createSlice({
    name: "limbah",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinLimbah.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            state.minDataKode = payload.dataKode;
            return state;
        },
        [getMinLimbah.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinLimbah.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getLimbah.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getLimbah.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getLimbah.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertLimbah.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertLimbah.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertLimbah.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateLimbah.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateLimbah.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateLimbah.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const limbahSelector = (state) => state.limbah;
